import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  TSidebarHiddenMenus,
  TSidebarMenuKey,
  TSidebarRole,
} from "../components/CommonComponents/Navbar/sidebar/sidebarMenuVisibility";
import { branchFeatureFlags } from "../config/branchFeatureFlags";
import { _axios } from "../utils/axios";

const BASE = "/sidebar-menu";
const KEY = "sidebar-menu";

/** Reads the switched-off sidebar entries of every role. */
export function fetchHiddenSidebarMenus() {
  return _axios.get<{ data: TSidebarHiddenMenus }>(BASE);
}

/**
 * The switched-off sidebar entries of every role. Nothing is asked of the
 * server for a municipality without the feature, or while `enabled` is false.
 */
export function useHiddenSidebarMenus({ enabled = true }: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: [KEY],
    queryFn: fetchHiddenSidebarMenus,
    select: (d) => d?.data?.data,
    enabled: branchFeatureFlags.ENABLE_SIDEBAR_MENU_CONFIG && enabled,
    staleTime: 0,
  });
}

/** Shows one entry to one role or hides it. The list is read again afterwards. */
export function useSetSidebarMenuVisibility() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: {
      role: TSidebarRole;
      menuKey: TSidebarMenuKey;
      visible: boolean;
    }) => _axios.put(BASE, body),
    retry: false,
    onSuccess: () => qc.invalidateQueries({ queryKey: [KEY] }),
  });
}
